import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import DocumentDropDown from './DocumentDropDown';
import DocumentCheckboxButton from './DocumentCheckboxButton';

const DocumentWrapper = styled<any, any>('li')`
    ${propStyles};
    position: relative;
    list-style: none;
`;

DocumentWrapper.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    flex: ['none', '0 0 50%'],
};

const DocumentType = styled<any, any>('div')`
    ${propStyles};
`;

DocumentType.defaultProps = {
    display: 'flex',
    flex: '1 0 auto',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginX: 'sm',
    marginY: 'xs',
    paddingY: 'sm',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
};

const DocumentTitle = styled<any, any>('h3')`
    ${propStyles};
`;

const DocumentSelector = styled<any, any>('div')`
    ${propStyles};
`;

DocumentSelector.defaultProps = {};

DocumentTitle.defaultProps = {
    flex: '1 0 auto',
    fontSize: 'inherit',
    fontWeight: 'normal',
    margin: '0 1em 0 0',
};

@inject('dataStore')
@observer
class Document extends Component<any, any> {
    @computed
    get documentCount() {
        return this.props.documents.length;
    }

    @computed
    get selectedCount() {
        return this.props.documents.filter(document =>
            this.props.documentSelected(document.clientCode)
        ).length;
    }

    @computed
    get title() {
        const { documentGroupName, documentTypeAliases } = this.props;
        if (
            documentGroupName &&
            documentTypeAliases &&
            documentTypeAliases[documentGroupName]
        ) {
            return documentTypeAliases[documentGroupName];
        }
        return documentGroupName;
    }

    render() {
        const { selectedCount, documentCount } = this;
        const {
            theme,
            dataStore,
            documents,
            toggleDownload,
            documentSelected,
            selectedDocumentsLabel,
            availableDocumentsLabel,
        } = this.props;

        const selectedLabel =
            selectedCount === 1
                ? selectedDocumentsLabel.singular
                : selectedDocumentsLabel.plural;

        const availableLabel =
            documentCount === 1
                ? availableDocumentsLabel.singular
                : availableDocumentsLabel.plural;

        const { isMobile } = dataStore;

        return (
            <DocumentWrapper>
                <DocumentType {...theme.DocumentType}>
                    <DocumentTitle
                        {...(isMobile
                            ? theme.DocumentTitleMobile
                            : theme.DocumentTitle)}
                    >
                        <Translate>{this.title}</Translate>
                    </DocumentTitle>
                    <DocumentSelector
                        {...(isMobile
                            ? theme.DocumentSelectorMobile
                            : theme.DocumentSelector)}
                    >
                        {documentCount > 1 ? (
                            <DocumentDropDown
                                documents={documents}
                                documentSelected={documentSelected}
                                toggleDownload={toggleDownload}
                                showCheckbox={true}
                            >
                                {selectedCount > 0 ? (
                                    <Translate
                                        placeholders={{
                                            selected: selectedCount,
                                            total: documentCount,
                                        }}
                                    >
                                        {selectedLabel}
                                    </Translate>
                                ) : (
                                    <Translate
                                        placeholders={{ total: documentCount }}
                                    >
                                        {availableLabel}
                                    </Translate>
                                )}
                            </DocumentDropDown>
                        ) : (
                            <DocumentCheckboxButton
                                document={documents[0]}
                                selected={documentSelected(
                                    documents[0].clientCode
                                )}
                                downloadDocuments={dataStore.downloadDocuments}
                                onChange={() => toggleDownload(documents[0])}
                                count={1}
                                showCount={false}
                                showCheckbox={true}
                                bgColor="transparent"
                                hover={{ bgColor: 'transparent' }}
                                borderStyle="none"
                                theme={{
                                    ...theme,
                                    ...{
                                        DocumentSelectLabel: {
                                            minWidth: '0',
                                        },
                                    },
                                }}
                            />
                        )}
                    </DocumentSelector>
                </DocumentType>
            </DocumentWrapper>
        );
    }
}

export default withTheme(Document) as any;



// WEBPACK FOOTER //
// ./src/Components/Document.tsx